module.exports = __webpack_public_path__ + "static/visaPermits-d1a6997a522d59486c086c66da95e49a.jpg";